import { Text } from 'components/Text'
import { styled } from 'stitches.config'

export const RealResultsRoot = styled('div', {
  background: '$accent-white',
  width: '100%',
  color: '$accent-black',
  padding: '$6 0',
})

export const ResultsContainer = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  margin: 'auto',
  maxWidth: '400px',
  width: '100%',
  gap: '$4',
  padding: '$4',
  flexWrap: 'wrap',

  '@bp2': {
    width: '100%',
    maxWidth: 'none',
    gap: '$5',
  },
})

export const ButtonWrapper = styled('div', {
  textAlign: 'center',
  marginTop: '$2',

  '@bp2': {
    marginTop: '$1',
  },
})

export const BadgeWrapper = styled('div', {
  position: 'absolute',
  top: '-110px',
  left: '50%',
  transform: 'translateX(-50%)',

  '@bp2': {
    top: '-20px',
    right: '20px',
    left: 'unset',
    transform: 'none',
  },
})

export const HeaderContainer = styled('div', {
  textAlign: 'center',
  width: '100%',
  maxWidth: '1100px',
  margin: 'auto',
  position: 'relative',
  paddingTop: '$8',

  '@bp2': {
    paddingTop: '0px',
  },
})

export const Header = styled('h2', {
  fontSize: '$h3',
  lineHeight: '$h3',
  letterSpacing: '$h3',
  marginBottom: '$2',
  '@bp2': {
    fontSize: '$h1',
    lineHeight: '$h1',
    letterSpacing: '$h1',
  },
})

export const Subheader = styled(Text, {
  width: '100%',
  maxWidth: '300px',
  margin: 'auto',
  marginBottom: '$1',

  '@bp2': {
    maxWidth: 'none',
    marginBottom: '$3',
  },
})

export const Benefit = styled(Text, {})

export const Result = styled('div', {
  width: '140px',
  textAlign: 'center',
})

export const Percentage = styled('h3', {
  fontSize: '$h2',
  lineHeight: '$h2',
  letterSpacing: '$h2'
})
